import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Topheader from './Components/topheader/Topheader';
import Navbar from './Components/navbar/Navbar';
import Header from './Components/Header/Header';
import './App.css'; // Ensure your styles are imported
import About from './Components/about/about';
import Ourproduct from './Components/ourproduct/ourproduct';
import Whychose from './Components/whychose/whychose';
import Aboutmain from './Components/about/aboutmain';
import Product from './Components/Products/Product';
import Gallery from './Components/gallery/galley';
import Contact from './Components/contact/Contact';
import Footer from './Components/footer/Footer';
import OurClients from './Components/our-client/Ourclient';
import Choose from './Components/Choose/Choose';
import Carrer from './Components/Carrerpage/Carrer';


function App() {
  return (
    <BrowserRouter>
      {/* <Topheader /> */}
      <Navbar />
      {/* <Header /> */}
      <div className="content"> {/* Pushes content down */}
     
        <Routes>
          <Route path="/" element={
            <>
             <Header/>
              <About />
              <Whychose />
              <OurClients/>
              {/* <Choose/> */}
         
              {/* <Ourproduct /> */}
            </>
          } />
          <Route path ="/aboutmain" element={<Aboutmain />} />
          <Route path ="/products" element={<Product />} />
          {/* <Route path ="/products/:category" element={<Product />} /> */}
          <Route path ="/gallery" element = {<Gallery/>}/>
          <Route path ="/contact" element = {<Contact/>}/> 
          <Route path = "/carrer" element = {<Carrer/>}/>
        

        </Routes>
      </div>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
